import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { space, tok, Typography } from '@sunwebgroup/ui-components'
import { type PropsWithChildren, useState } from 'react'
import { styled } from 'styled-components'
import { HeaderLink } from '../HeaderLink'
import { Menu } from './Menu'
import { MenuTrigger } from './Trigger'

const Wrapper = styled(NavigationMenu.Content)`
  height: 100%;
`

const NavigationMenuViewport = styled(NavigationMenu.Viewport)<{ $activeItem?: string }>`
  & > :not([id$='${({ $activeItem }) => $activeItem}']) {
    display: none;
  }
`

const StyledSubMenu = styled(NavigationMenu.Sub)`
  display: flex;
  height: 100%;
`

const SubMenuContent = styled.div`
  background: ${tok('semantics_backgrounds_tinted_background_color')};
  border-right: 1px solid ${tok('semantics_dividers_color')};
  padding: ${space('primitives_space_24')} 0;

  > ${Typography} {
    display: block;
    padding: ${space('primitives_space_8')} ${space('primitives_space_24')};
  }
`

const SubMenuList = styled(NavigationMenu.List)`
  list-style: none;
  margin: 0;
  min-width: 250px;
  padding: 0;

  > * {
    & > ${HeaderLink} {
    width: 100%;
  }
}

  ${MenuTrigger} {
    border-radius: 0;
    width: 100%;
  }
`

const SubMenuActiveContent = styled.div`
  padding: ${space('primitives_space_24')} 0;
  width: -webkit-fill-available;

  h3 {
    display: block;
    padding: ${space('primitives_space_8')} ${space('primitives_space_24')};
  }
`

SubMenu.List = SubMenuList
SubMenu.Item = Menu.Item

export interface SubMenuProps extends NavigationMenu.NavigationMenuSubProps {
  label: string
}

export function SubMenu({ children, label }: PropsWithChildren<SubMenuProps>) {
  const [valueMenu, setValueMenu] = useState('')
  return (
    <>
      <MenuTrigger onPointerMove={(e: React.PointerEvent) => e.preventDefault()}>{label}</MenuTrigger>
      <Wrapper forceMount>
        <StyledSubMenu orientation="vertical" value={valueMenu} onValueChange={setValueMenu}>
          <SubMenuContent>
            <Typography as="h2" $variant="body-md-bold">
              {label}
            </Typography>
            <SubMenuList>{children}</SubMenuList>
          </SubMenuContent>
          <SubMenuActiveContent>
            <NavigationMenuViewport $activeItem={valueMenu} />
          </SubMenuActiveContent>
        </StyledSubMenu>
      </Wrapper>
    </>
  )
}
